import { useQuestionizerStore } from "../types/state.ts";
import Radio from "./radio.tsx";
import Toggle from "./toggle.tsx";

export default function InputGebaeudeTyp3 (props: {
  id: number, 
  label?: string,
  label_einfamilienhaus?: string, 
  icon_einfamilienhaus: string, 
  icon_einfamilienhaus_active?: string, 
  label_mehrfamilienhaus?: string, 
  icon_mehrfamilienhaus: string, 
  icon_mehrfamilienhaus_active?: string,
  label_nichtwohngebaeude?: string,
  icon_nichtwohngebaeude: string,
  icon_nichtwohngebaeude_active?: string,
  onBlur?: ()=>void
}){
  const updateValidation = useQuestionizerStore((state) => state.updateValidation);
  const gebaeude = useQuestionizerStore((state) => state.gebaeude);
  const setGebaeude = useQuestionizerStore((state) => state.setGebaeude);
  const setGewerbegebaeude = useQuestionizerStore((state) => state.setGewerbegebaeude);
  const setGemeinnuetzig = useQuestionizerStore((state) => state.setGemeinnuetzig);
  //const wohngebaeude = useQuestionizerStore((state) => state.wohngebaeude);
  const setWohngebaeude = useQuestionizerStore((state) => state.setWohngebaeude);
  //const error_default = useQuestionizerStore((state) => state.E('input-gebaeudetyp--default'));
  const label_einfamilienhaus = props.label_einfamilienhaus || useQuestionizerStore((state) => state.L('input-gebaeudetyp--einfamilienhaus'));
  const label_mehrfamilienhaus = props.label_mehrfamilienhaus || useQuestionizerStore((state) => state.L('input-gebaeudetyp--mehrfamilienhaus'));
  const label_nichtwohngebaeude = props.label_nichtwohngebaeude || useQuestionizerStore((state) => state.L('input-gebaeudetyp--nichtwohngebaeude'));

  return <fieldset className={"section__inputs section__inputs--grid mb-8 input-"+props.id}>
        <legend>{props.label}</legend>
        <Radio name="gebaeudetyp" id={props.id+"-efh"} label={label_einfamilienhaus} icon={props.icon_einfamilienhaus} icon_active={props.icon_einfamilienhaus_active} value={gebaeude == "Einfamilienhaus"} onBlur={props.onBlur} onChange={(_)=>{
          setGebaeude("Einfamilienhaus");  
          setWohngebaeude(true);
		  setGewerbegebaeude(false);
		  setGemeinnuetzig(false);
          updateValidation();     
        }}/>
        <Radio name="gebaeudetyp" id={props.id+"-mfh"} label={label_mehrfamilienhaus} icon={props.icon_mehrfamilienhaus} icon_active={props.icon_mehrfamilienhaus_active} value={gebaeude == "Mehrfamilienhaus"} onBlur={props.onBlur} onChange={(_)=>{
          setGebaeude("Mehrfamilienhaus");   
          setWohngebaeude(true);
		  setGewerbegebaeude(false);
		  setGemeinnuetzig(false);
          updateValidation();    
        }}/>
         <Radio name="gebaeudetyp" id={props.id+"-nwg"} label={label_nichtwohngebaeude} icon={props.icon_nichtwohngebaeude} icon_active={props.icon_nichtwohngebaeude_active} value={gebaeude == "Nichtwohngebäude"} onBlur={props.onBlur} onChange={(_)=>{
          setGebaeude("Nichtwohngebäude");
          setWohngebaeude(false);
		  setGewerbegebaeude(true);
		  setGemeinnuetzig(true);
          updateValidation();
        }}/>
    </fieldset>
}